import { createApi } from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/api/axios";

export const baseApi = createApi({
    reducerPath: "api",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["Language", "MainVisual", "DashBoard", "Patent", "NewsRoom", "Category", "Product", "Privacy", "Faq"],
    endpoints: () => ({}),
});

